<template>
  <div class="select-wrap" tabindex="0" @focus="focuesEvent" @blur="blurEvent">
    <div class="select-container" @click="selectEvent">
      <div class="select-content">
        <p
          class="select-value"
          :class="{ 'select-place': sellabel === placeholder }"
        >
          {{ sellabel }}
        </p>
      </div>
      <div class="select-jiantou">
        <i></i>
      </div>
    </div>

    <!-- 下拉框 -->
    <transition name="select-option-container">
      <div class="select-option-container" v-show="selectOptionShow">
        <div
          class="select-option"
          :class="{ selected: item.label === sellabel }"
          v-for="(item, index) in optionsList"
          :key="`option-${index}`"
          @click="selectedEvent(item)"
        >
          {{ item.label }}
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "SelectBox",
  props: {
    optionsList: {
      type: Array,
    },
    defaultValue: {
      type: Number | String,
    },
    placeholder: {
      type: String,
    },
  },

  components: {},
  data: () => ({
    selectOptionShow: false,
    sellabel: "",
  }),
  created() {
    this.sellabel = this.placeholder;
  },
  mounted() {},
  watch: {
    defaultValue(val) {
      if (val) {
        for (let i = 0, len = this.optionsList.length; i < len; i++) {
          if (this.optionsList[i].value == val) {
            console.log(this.optionsList[i]);
            this.selectedEvent(this.optionsList[i]);
          }
        }
      }
    }
  },
  computed: {},
  methods: {
    selectEvent() {
      this.selectOptionShow = !this.selectOptionShow;
    },
    selectedEvent(item) {
      this.sellabel = item.label;
      this.$emit("input", item.value);
      this.selectOptionShow = false;
    },
    focuesEvent() {},
    blurEvent() {
      this.selectOptionShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.select-wrap {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 990;
  outline: none;

  .select-container {
    width: 100%;
    height: 100%;
    display: flex;
    box-sizing: border-box;
    background: #fff;

    .select-content {
      flex: 1;
      height: 100%;
      box-sizing: border-box;
      padding: 0 10px;
      display: flex;
      align-items: center;

      .select-value {
        color: #a0a0a0;
        font-size: pxTorem(18px);

        &.select-place {
          color: #a0a0a0;
        }
      }
    }
    .select-jiantou {
      width: pxTorem(26px);
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #0062d0;

      i {
        width: 0;
        height: 0;
        border: pxTorem(5px) solid transparent;
        border-bottom: pxTorem(8px) solid #fff;
        transform: translateY(-25%);
      }
    }
  }

  .select-option-container {
    position: absolute;
    background: #fff;
    width: 100%;
    max-height: pxTorem(150px);
    box-sizing: border-box;
    left: 0;
    top: 110%;
    z-index: 999;
    transform-origin: center top;
    overflow-y: auto;
    @include hideScrollBar;

    .select-option {
      font-size: pxTorem(16px);
      color: #a0a0a0;
      width: 100%;
      padding: 8px 10px;
      cursor: pointer;
      box-sizing: border-box;

      &:hover {
        color: #fff;
        background: #0062d0;
      }
      &.selected {
        color: #fff;
        background: #0062d0;
      }
    }
  }

  .select-option-container-enter-active,
  .select-option-container-leave-active {
    transition: all 0.1s ease-in-out;
  }
  .select-option-container-enter,
  .select-option-container-leave-to {
    transform: scale(1, 0);
  }
}
</style>
